import { render, staticRenderFns } from "./MenuOption.vue?vue&type=template&id=31c6d3dc"
import script from "./MenuOption.vue?vue&type=script&lang=js"
export * from "./MenuOption.vue?vue&type=script&lang=js"
import style0 from "./MenuOption.vue?vue&type=style&index=0&id=31c6d3dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports